import React, { Component } from 'react'
import SectionHeader from '../components/sections/SectionHeader'
import Card7 from '../components/cards/Card7'
import LocationsSvg from '../components/icons/LocationsSvg'
import PhoneSvg from '../components/icons/PhoneSvg'
import LetterSvg1 from '../components/icons/LetterSvg1'
import PagesHeader from '../components/sections/PagesHeader'
import successImage from '../images/successImage.png'
import { Helmet } from 'react-helmet'

export class ContactUs extends Component {
    state = {
        name: '',
        subject: '',
        email: '',
        number: '',
        email: '',
        message: '',
        errors: {},
        showSuccessPopup: false,
        isSubmitting: false,
    };

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    validateForm = () => {
        const { name, email, number, subject, message } = this.state;
        let errors = {};
        let formIsValid = true;

        // Name validation
        if (!name) {
            formIsValid = false;
            errors['name'] = 'Ad boş ola bilməz';
        }

        // Email validation
        if (!email) {
            formIsValid = false;
            errors['email'] = 'Email boş ola bilməz';
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            formIsValid = false;
            errors['email'] = 'Email formatı düzgün deyil';
        }

        // Phone number validation
        if (!number) {
            formIsValid = false;
            errors['number'] = 'Nömrənizi düzgün yazdığınızdan əmin olun';
        } else if (number.length !== 9) {
            formIsValid = false;
            errors['number'] = 'Nömrənizi düzgün yazdığınızdan əmin olun';
        }

        // Subject validation
        if (!subject) {
            formIsValid = false;
            errors['subject'] = 'Mövzu boş ola bilməz';
        }

        // Message validation
        // if (!message) {
        //     formIsValid = false;
        //     errors['message'] = 'Mesaj boş ola bilməz';
        // }

        this.setState({ errors });
        return formIsValid;
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        if (!this.validateForm()) {
            return;
        }

        this.setState({ isSubmitting: true });
        const { name, email, number, subject, message } = this.state;

        const TELEGRAM_API_URL = `https://api.telegram.org/bot7731980299:AAFn6Kl3ODisCVYjwlbBY7uabBfpJOTrVgY/sendMessage`;
        const text = `Yeni mesaj:\nAd: ${name}\nEmail: ${email}\nTelefon: +994${number}\nMövzu: ${subject}\n\nMesaj: ${message}`;

        try {
            const response = await fetch(TELEGRAM_API_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    chat_id: '6446095780',
                    text: text,
                }),
            });

            if (response.ok) {
                this.setState({
                    name: '',
                    email: '',
                    number: '',
                    subject: '',
                    message: '',
                    errors: {},
                    showSuccessPopup: true,
                });  // Form temizlenir

                setTimeout(() => {
                    this.setState({ showSuccessPopup: false });  // Popup'ı 3 saniye sonra gizle
                }, 3000);
            } else {
                alert('Mesaj göndərilərkən bir xəta oldu.');
            }
        } catch (error) {
            console.error('Telegram botuna mesaj gönderilirken bir hata oluştu:', error);
            alert('Mesaj göndərilmədi.');
        }

        this.setState({ isSubmitting: false });
    };

    render() {
        const { errors, showSuccessPopup, isSubmitting } = this.state;
        return (
            <main className='bg-[#f4f8fc]'>

                <Helmet>
                    {/* Meta Title */}
                    <title>ITnova Əlaqə - İT Xidmətləri və Texnoloji Həllər Üçün Bizimlə Əlaqə Saxlayın</title>

                    {/* Meta Description */}
                    <meta name="description" content="IT xidmətləri, veb dizayn, mobil tətbiq hazırlığı və SEO üzrə suallarınız var? ITnova ilə əlaqə saxlayın və biznesiniz üçün ən yaxşı texnoloji həlləri əldə edin." />

                    {/* Meta Keywords */}
                    <meta name="keywords" content="ITnova əlaqə, İT xidmətləri əlaqə, veb dizayn əlaqə, mobil tətbiq hazırlığı əlaqə, SEO əlaqə, robototexnika əlaqə, texnoloji həllər, itnova.az, İT şirkəti, Azərbaycan, əlaqə məlumatları" />

                    {/* Open Graph Meta Tags (for social sharing) */}
                    <meta property="og:title" content="ITnova Əlaqə - İT Xidmətləri və Texnoloji Həllər Üçün Bizimlə Əlaqə Saxlayın" />
                    <meta property="og:description" content="IT xidmətləri, veb dizayn, mobil tətbiq hazırlığı və SEO üzrə suallarınız var? ITnova ilə əlaqə saxlayın və biznesinizə texnoloji həllər tapın." />
                    <meta property="og:url" content="https://itnova.az/contact-us" />
                    <meta property="og:type" content="website" />
                    <meta property="og:image" content="https://itnova.az/static/media/logo.76d56b1f9b610982be1a.png" /> {/* Loqonun URL ünvanını əlavə edin */}
                </Helmet>

                <PagesHeader
                    title="Bizimlə əlaqə saxlayın"
                    text="Sizə necə kömək edə bilərik? İşinizi rəqəmsal aləmə daşımaq üçün nə etməli olduğunuzu bizimlə müzakirə edin. Müraciət etmək üçün sadəcə formu doldurun və ya bizimlə birbaşa əlaqə saxlayın. Sizi dinləmək üçün buradayıq!"
                    className="header_back1"

                />

                <section className='p-[52px_0px] container max-[600px]:p-[32px_0px]  '>
                    <div className='flex flex-col items-center'>
                        <span className='text-[var(--orange)] text-[16px] font-[600]'>Mesaj göndərməkdən çəkinməyin</span>
                        <SectionHeader title="Əlaqə" className="max-[320px]:text-[16px]" />
                    </div>

                    <div className=' max-[900px]:w-full max-[900px]:flex max-[900px]:justify-center'>
                        <div className='bg-[#fff] shadow-lg rounded-[8px] p-[50px_0px] mt-[32px] grid grid-cols-3 items-center max-[900px]:grid-cols-1 max-[900px]:gap-[32px] max-[900px]:w-[75%] max-[600px]:p-[24px_0px] '>
                            <Card7
                                className="border-r-[1px] max-[900px]:border-r-[0px]"
                                icon={<LocationsSvg className="contact-svg" />}
                                title="Ünvan"
                                adress="Bakı, Xocalı pr.14"
                            />
                            <Card7
                                className="border-r-[1px] max-[900px]:border-r-[0px]"
                                icon={<PhoneSvg fill="var(--orange)" className="contact-svg" />}
                                title="Nömrə"
                                info="+994 70 656 22 02"

                            />
                            <Card7
                                icon={<LetterSvg1 className="contact-svg" />}
                                title="Email"
                                mail="info@itnova.az"
                            />

                        </div>
                    </div>

                </section>

                <section className='mt-[32px] pb-[52px]  container max-[900px]:w-full max-[900px]:flex max-[900px]:justify-center'>
                    <div className='p-[50px] bg-[#fff] rounded-[8px] flex flex-col gap-[20px]  shadow-lg  max-[900px]:w-[75%] max-[600px]:w-[81%] max-[400px]:w-[85%] max-[500px]:gap-[15px] max-[600px]:p-[24px] '>
                        <form onSubmit={this.handleSubmit}>

                            <div className='grid grid-cols-2 gap-[20px] max-[900px]:grid-cols-1'>
                                <div className='w-full'>
                                    <input
                                        type='text'
                                        name='name'
                                        value={this.state.name}
                                        className='bg-[#f4f8fc] w-full p-[14px] text-[18px] rounded-[8px] max-[900px]:text-[16px]'
                                        placeholder='Ad'
                                        onChange={this.handleChange}
                                    />
                                    {errors.name && <div className="text-red-500">{errors.name}</div>}
                                </div>

                                <div className='w-full'>
                                    <input
                                        type='email'
                                        name='email'
                                        value={this.state.email}
                                        onChange={this.handleChange}
                                        className='bg-[#f4f8fc] w-full p-[14px] text-[18px] rounded-[8px]  max-[900px]:text-[16px]'
                                        placeholder='Email'
                                    />
                                    {errors.email && <div className="text-red-500">{errors.email}</div>}
                                </div>

                                <div className='w-full'>
                                    <div className='flex items-center gap-[8px] bg-[#f4f8fc] p-[14px] rounded-[8px] text-[18px]  max-[900px]:text-[16px] ' >
                                        <span>+994</span>
                                        {/* <input
                                            type='tel'
                                            name='number'
                                            value={this.state.number}
                                            onChange={this.handleChange}
                                            className=' bg-[#f4f8fc] w-full h-full  '
                                            placeholder='Nömrə'
                                            maxLength={9}
                                        /> */}
                                        <input
                                            type='tel'  // Telefon numarası olduğu için 'tel' kullanıyoruz
                                            name='number'
                                            value={this.state.number}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                // Sadece rakamları kabul eden bir regex kontrolü
                                                if (/^\d*$/.test(value)) {
                                                    this.setState({ number: value });
                                                }
                                            }}
                                            maxLength={9}  // Maksimum 9 rakama izin veriyoruz
                                            className='bg-[#f4f8fc] w-full text-[18px] rounded-[8px] max-[900px]:text-[16px]'
                                            placeholder='Nömrə'
                                        />
                                    </div>
                                    {errors.number && <div className="text-red-500">{errors.number}</div>}
                                </div>


                                <div className='w-full'>
                                    <input
                                        type='text'
                                        name='subject'
                                        value={this.state.subject}
                                        onChange={this.handleChange}
                                        className='bg-[#f4f8fc] p-[14px] w-full text-[18px] rounded-[8px]  max-[900px]:text-[16px]'
                                        placeholder='Mövzu'
                                    />
                                    {errors.subject && <div className="text-red-500">{errors.subject}</div>}

                                </div>

                            </div>

                            <div className='w-full min-h-[200px] mt-[20px] max-[500px]:min-h-[150px]'>
                                <textarea
                                    name="message"
                                    value={this.state.message}
                                    onChange={this.handleChange}
                                    className='bg-[#f4f8fc] p-[14px] text-[18px] rounded-[8px]  max-[900px]:text-[16px] w-full min-h-[250px] max-[500px]:min-h-[150px]'
                                    placeholder='Mesaj'
                                />
                            </div>

                            <div className='flex justify-center mt-[20px]'>
                                <button
                                    type='submit'
                                    className='bg-[#0E38B1] text-[#fff] text-[18px] font-[500] p-[10px_24px] rounded-[8px] flex items-center gap-[8px]  max-[900px]:text-[16px] max-[900px]:p-[12px_28px]'
                                    disabled={isSubmitting}
                                >
                                    Göndər
                                </button>
                            </div>
                        </form>

                        {showSuccessPopup && (
                            <div className='success-popup'>
                                <div className='success-popup-content p-[40px_80px] max-[350px]:p-[18px_34px] m-[16px] rounded-[8px]'>
                                    {/* <p className='bg-[red]'>Tewekkürlər! Qeydiyyatınız uğurla tamamlandı.</p> */}
                                    <div className=' '>
                                        <div className='flex justify-center'>
                                            <img src={successImage} className='w-[160px] h-[160px] max-[350px]:w-[130px] max-[350px]:h-[130px]' />
                                        </div>

                                        <h3 className='text-[22px] text-center font-[600] text-green-500'>
                                            Mesajınız uğurla göndərildi!
                                        </h3>
                                    </div>
                                </div>
                            </div>
                            // <div className='fixed  bg-green-500 text-white p-[16px] rounded-[8px] shadow-lg'>
                            //     Mesajınız uğurla göndərildi!
                            // </div>
                        )}
                    </div>
                </section>
            </main>
        )
    }
}

export default ContactUs